import React from "react"
import { css } from "emotion"
import {
  BACKGROUND,
  UNSTUCK_GREEN,
  PRIMARY_TEXT,
  SECONDARY_TEXT,
} from "../constants"
import Text from "./Text"

const Label = ({ label, labelLeft }) => {
  return (
    <div
      className={css`
        position: absolute;
        top: 0px;
        left: ${labelLeft ? "auto" : "100%"};
        right: ${labelLeft ? "100%" : "auto"};
        padding: 5px;
        transform: translateY(-50%);
        white-space: nowrap;
        text-align: ${labelLeft ? "right" : "left"};
        color: ${SECONDARY_TEXT};
      `}>
      {label}
    </div>
  )
}

const Line = ({ offset, label, labelLeft }) => {
  return (
    <div
      className={css`
        z-index: 2;
        position: absolute;
        top: ${offset * 100}%;
        left: 0;
        right: 0;
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
      `}>
      <Label label={label} labelLeft={labelLeft} />
    </div>
  )
}

const Bar = ({ offset, label, labelLeft }) => {
  return (
    <div
      className={css`
        z-index: 1;
        position: absolute;
        top: ${offset * 100}%;
        left: 0;
        right: 0;
        height: ${100 - offset * 100}%;
        background: ${UNSTUCK_GREEN};
        border-top: 2px solid ${PRIMARY_TEXT};
      `}>
      <Label label={label} labelLeft={labelLeft} />
    </div>
  )
}

const Graph = ({ top, bottom, avg, score, format = n => n, labels }) => {
  const lowest = Math.min(top, bottom, avg, score)
  const highest = Math.max(top, bottom, avg, score)
  const range = highest - lowest
  const topOffset = (highest - top) / range
  const bottomOffset = (highest - bottom) / range
  const avgOffset = (highest - avg) / range
  const scoreOffset = (highest - score) / range
  const avgScoreDiff = Math.abs(avgOffset - scoreOffset)
  const topLabel = `${format(top)} ${(labels && labels.top) || "(top 10%)"}`
  const bottomLabel = `${format(bottom)} ${(labels && labels.bottom) ||
    "(bottom 10%)"}`
  const avgLabel = (labels && labels.avg) || "average"

  return (
    <figure
      className={css`
        position: relative;
        width: 80px;
        height: 200px;
        background: ${BACKGROUND};
        &:before,
        &:after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          height: 10px;
        }
        &:before {
          bottom: 100%;
          background: ${BACKGROUND};
          border-radius: 4px 4px 0 0;
        }
        &:after {
          top: 100%;
          background: ${UNSTUCK_GREEN};
          border-radius: 0 0 4px 4px;
        }
      `}>
      <Bar
        offset={scoreOffset}
        label={
          <div style={{ color: PRIMARY_TEXT }}>
            <Text.H4 bold style={{ lineHeight: "0.5em" }}>
              {format(score)}
            </Text.H4>
            <Text.Small>your score</Text.Small>
          </div>
        }
        labelLeft
      />
      <Line offset={topOffset} label={<Text.Small>{topLabel}</Text.Small>} />
      <Line
        offset={bottomOffset}
        label={<Text.Small>{bottomLabel}</Text.Small>}
      />
      <Line
        offset={avgOffset}
        labelLeft={avgScoreDiff > 0.2}
        label={
          <div>
            <Text.H4 bold style={{ lineHeight: "0.5em" }}>
              {format(avg)}
            </Text.H4>
            <Text.Small>{avgLabel}</Text.Small>
          </div>
        }
      />
    </figure>
  )
}

export default Graph



// WEBPACK FOOTER //
// ./src/components/Graph.js